import DocumentContext from '../../../providers/DocumentContext'
import getNameType from '../EditorView/functions/getNameType'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import { makeStyles } from '@material-ui/core/styles'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import DeleteForeverIcon from '@material-ui/icons/DeleteForever'
import DragIndicatorIcon from '@material-ui/icons/DragIndicator'
import { useContext } from 'react'
import { toast } from 'react-toastify'
import TemplateLib from '~/common/libs/interview-template-lib'
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core'
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
  useSortable,
} from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

const useStyles = makeStyles(({ palette, spacing }) => ({
  title: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px 20px',
    fontSize: 16,
    borderBottom: ' 1px solid silver',
  },
  button: {
    width: 25,
    height: 25,
    minHeight: 25,
    marginLeft: 10,
  },
  table: {
    padding: 0,
    margin: '15px 0px',
    border: '1px solid grey',
    borderRadius: 5,
    backgroundColor: 'white',
  },
  tableHead: {
    fontSize: 12,
    padding: 5,
    color: 'black',
    borderBottom: ' 0.2px solid silver',
  },
  tableCellId: {
    fontSize: 10,
    padding: 5,
    color: 'grey',
  },
  tableCell: {
    fontSize: 10,
    padding: 5,
  },
  row: {
    cursor: 'pointer',
    transition: '0.1s',
    '&:hover': {
      backgroundColor: '#ddd!important',
    },
  },
  dragging: {
    opacity: 0.5,
  },
  dragHandle: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'grab',
    marginRight: 10,
    color: '#666',
    '&:hover': {
      color: '#333',
    },
    '&:active': {
      cursor: 'grabbing',
    },
  },
  badge: {
    color: 'white',
    fontWeight: 'bold',
    padding: '5px 15px',
    borderRadius: 5,
    textShadow: 'grey 1.4px 0.4px',
  },
}))

// Composant pour un élément de variable sortable
function SortableVariableItem({ id, children, variable, onDelete, onSetDialog, classes }) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id,
  })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    display: 'table-row',
    opacity: isDragging ? 0.5 : 1,
  }

  return (
    <TableRow
      ref={setNodeRef}
      style={style}
      className={classes.row}
      onClick={(e) => {
        if (e.target.closest('.deleteButton') === null) {
          onSetDialog(variable)
        }
      }}
    >
      <TableCell className={classes.tableCell} style={{ width: 40 }} align="center">
        <div
          {...attributes}
          {...listeners}
          className={classes.dragHandle}
          style={{ display: 'inline-flex', alignItems: 'center' }}
        >
          <DragIndicatorIcon style={{ fontSize: 16 }} />
        </div>
      </TableCell>
      {children}
    </TableRow>
  )
}

export default function List({
  list,
  setvariableDialog,
  isUnsuedGlobalVariable,
  isUnsuedLocalVariable,
  setUnusedGlobalVariables,
  setUnusedLocalVariables,
}) {
  const classes = useStyles()
  const { document, updateDocument } = useContext(DocumentContext)

  const findField = (node, fieldId) => {
    if (node && node.fields) {
      for (let field of node.fields) {
        if (field.id == fieldId) {
          return field
        }
      }
    }
    // Recurse into each child
    if (node && node.children) {
      for (let child of node.children) {
        let foundField = findField(child, fieldId)
        if (foundField) return foundField
      }
    }
    return null
  }

  const deleteMapping = async (variable) => {
    TemplateLib.getObjectModels()
      .then((res) => {
        let databaseObjectModels = res.data.results
        for (const mappings of variable.database_object_model_fields_mapping) {
          if (mappings === null || mappings.database_object_model_name === '') {
            continue
          }
          let model = databaseObjectModels.find(
            (model) => model.definitionJson.name === mappings.database_object_model_name
          )
          console.log('Updating DP model', model.definitionJson.name)
          mappings.data.forEach((data) => {
            if (!data.database_object_model_field_id) return
            let modelField = findField(model.definitionJson, data.database_object_model_field_id)
            console.log('found modelField', modelField)

            if (modelField !== undefined) {
              modelField.existingMapping = modelField.existingMapping.filter(
                (m) => m.variableId !== variable.id
              )
              console.log('updating existingMapping', modelField.existingMapping)
            }
          })
          TemplateLib.updateObjectModels(model)
        }
      })
      .catch((e) => {
        console.error('Failed to fetch database object models:', e)
      })
  }

  const deleteVariable = async (row) => {
    if (window.confirm('Voulez vous vraiment supprimer cette variable :' + row.name)) {
      const copy = { ...document }
      try {
        // Remove the DatabaseObjectModel mapping
        await deleteMapping(row)
      } catch (e) {
        console.error('Error deleting mapping', e)
        toast.error('Erreur durant la suppression de la variable')
        return
      }
      if (isUnsuedGlobalVariable && !isUnsuedLocalVariable) {
        TemplateLib.deleteVariable(row.id).then(() => {
          setUnusedGlobalVariables(list.filter((el) => el.id !== row.id))
          const isExists = copy.variables.find((variable) => {
            return variable.id === row.id
          })
          if (isExists) {
            deleteAndReorderVariables(row)
          }
          toast.success('Suppression de la variable enregistrée.')
        })
      }
      if (!isUnsuedGlobalVariable && isUnsuedLocalVariable) {
        TemplateLib.deleteVariable(row.id).then(() => {
          setUnusedLocalVariables(list.filter((el) => el.id !== row.id))
          const isExists = copy.variables.find((variable) => {
            return variable.id === row.id
          })
          if (isExists) {
            deleteAndReorderVariables(row)
          }
          toast.success('Suppression de la variable enregistrée.')
        })
      }
      if (!isUnsuedGlobalVariable && !isUnsuedLocalVariable) {
        TemplateLib.deleteVariable(row.id).then(() => {
          deleteAndReorderVariables(row)
          TemplateLib.getUnusedGlobalVariable(document.project).then((result) => {
            setUnusedGlobalVariables(result)
          })
          TemplateLib.getUnusedLocalVariable(document.project).then((result) => {
            setUnusedLocalVariables(result)
          })
          toast.success('Suppression de la variable enregistrée.')
        })
      }
    }
  }

  const deleteAndReorderVariables = (row) => {
    const copy = { ...document }
    copy.variables = copy.variables.filter((el) => el.id !== row.id)
    updateDocument(copy)
  }

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 8,
      },
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  )

  // Always work with the same ordering as what is rendered (sorted by order_in_group)
  const sortedList = [...list].sort((a, b) => a.order_in_group - b.order_in_group)

  const handleDragEnd = (event) => {
    const { active, over } = event

    if (!over) return

    if (active.id !== over.id) {
      // Compute indexes based on the rendered order (sortedList), not the raw prop order
      const oldIndex = sortedList.findIndex((item) => `var-${item.id}` === active.id)
      const newIndex = sortedList.findIndex((item) => `var-${item.id}` === over.id)

      if (oldIndex !== -1 && newIndex !== -1) {
        // Update UI order immediately based on the rendered list
        const newList = arrayMove(sortedList, oldIndex, newIndex)

        // Update order in the database only when it actually changed
        newList.forEach((item, index) => {
          if (item.order_in_group !== index + 1) {
            TemplateLib.updateVariable(item.id, {
              ...item,
              order_in_group: index + 1,
            }).catch(() => {
              toast.error("Erreur lors de la mise à jour de l'ordre des variables")
            })
          }
        })

        // Update the document with the new order values
        const updatedDocument = { ...document }
        newList.forEach((item, index) => {
          const varIndex = updatedDocument.variables.findIndex((v) => v.id === item.id)
          if (varIndex !== -1) {
            updatedDocument.variables[varIndex].order_in_group = index + 1
          }
        })
        updateDocument(updatedDocument)
      }
    }
  }

  return (
    <div style={{ margin: '15px 10px' }}>
      <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
        <TableContainer className={classes.table}>
          <Table stickyHeader style={{ padding: 0, border: '1px solid silver' }}>
            <TableHead>
              <TableRow>
                <TableCell className={classes.tableHead}></TableCell>
                <TableCell className={classes.tableHead} align="center">
                  ID
                </TableCell>
                <TableCell className={classes.tableHead} align="center">
                  Nom
                </TableCell>
                <TableCell className={classes.tableHead} align="center">
                  Type
                </TableCell>
                <TableCell className={classes.tableHead} align="center">
                  Globale
                </TableCell>
                <TableCell className={classes.tableHead} align="center"></TableCell>
              </TableRow>
            </TableHead>
            <TableBody style={{ maxHeight: 300 }}>
              <SortableContext
                items={sortedList.map((item) => `var-${item.id}`)}
                strategy={verticalListSortingStrategy}
              >
                {sortedList.map((row) => (
                  <SortableVariableItem
                    key={`var-${row.id}`}
                    id={`var-${row.id}`}
                    variable={row}
                    onDelete={() => deleteVariable(row)}
                    onSetDialog={setvariableDialog}
                    classes={classes}
                  >
                    <TableCell className={classes.tableCellId} align="center">
                      #{row.id}
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      align="center"
                      style={{ fontSize: 14 }}
                    >
                      {row.name}
                    </TableCell>
                    <TableCell className={classes.tableCell} align="center">
                      {getNameType(row.type)}
                    </TableCell>
                    <TableCell className={classes.tableCell} align="center">
                      {row.is_global && (
                        <CheckCircleIcon color="primary" style={{ fontSize: 18 }} />
                      )}
                    </TableCell>
                    <TableCell
                      className={classes.tableCell + ' deleteButton'}
                      align="center"
                      onClick={(e) => {
                        e.stopPropagation()
                        deleteVariable(row)
                      }}
                    >
                      <DeleteForeverIcon
                        className="deleteButton"
                        style={{
                          fontSize: 18,
                          color: '#f93b3b',
                          cursor: 'pointer',
                        }}
                      />
                    </TableCell>
                  </SortableVariableItem>
                ))}
              </SortableContext>
            </TableBody>
          </Table>
        </TableContainer>
      </DndContext>
    </div>
  )
}
